import { FC, useMemo } from 'react';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd } from 'next-seo';
import { ItemListElements } from 'next-seo/lib/types';

import { BreadcrumbItem } from './types';

type BreadcrumbsSeoProps = {
  items: BreadcrumbItem[];
  currentPageName?: string;
};

export const BreadcrumbsSeo: FC<BreadcrumbsSeoProps> = ({ items, currentPageName }) => {
  const { asPath } = useRouter();

  const itemListElements: ItemListElements[] = useMemo(() => {
    const breadcrumbsItems = items.map(({ label, href }, index) => ({
      position: index + 1,
      name: label,
      item: process.env.NEXT_PUBLIC_SITE_BASE_URL + href
    }));

    if (currentPageName) {
      breadcrumbsItems.push({
        position: breadcrumbsItems.length + 1,
        name: currentPageName,
        item: process.env.NEXT_PUBLIC_SITE_BASE_URL + asPath
      });
    }

    return breadcrumbsItems;
  }, [asPath, currentPageName, items]);

  return <BreadcrumbJsonLd itemListElements={itemListElements} />;
};
